import script from "./MenuTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuTabs.vue?vue&type=script&setup=true&lang=js"

import "./MenuTabs.vue?vue&type=style&index=0&id=dbce83ac&lang=scss"

const __exports__ = script;

export default __exports__